import { Component, OnInit } from '@angular/core';
import { PageService } from '@services/page.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-pprivacy',
  templateUrl: './pprivacy.component.html',
  styleUrls: ['./pprivacy.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class PprivacyComponent implements OnInit {

  
  application = "page";
  component = 'm';
  params: any = [];
  comments: any = [];
  id = "";
  response: any = [];
  page_content="";
  constructor(private _pageService: PageService,private route: ActivatedRoute, private _global: GlobalService) {
    this._pageService.view({ id: '05434a80-5008-3c5d-a4c7-44dd25bc878a' }).subscribe(
      pageData => {
        if (this._global.getVal(pageData, 'response', '')) {
          this.response = this._global.getVal(pageData, 'response', {});
          this.page_content =this._global.getVal(this.response, 'content', 'Page is not available!'); 
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  ngOnInit() {
  }

}
